export default function FeatureComparison() {
  const rows = [
    { feature: "Automation Capability", traditional: "Low – Manual entry required", acbuy: "High – Smart automation built-in", traditionalIcon: "ri-close-circle-line text-red-400", acbuyIcon: "ri-checkbox-circle-line text-green-500" },
    { feature: "Data Accuracy", traditional: "Medium – Prone to human error", acbuy: "High – Validation & error checking", traditionalIcon: "ri-error-warning-line text-amber-400", acbuyIcon: "ri-checkbox-circle-line text-green-500" },
    { feature: "Scalability", traditional: "Limited – Breaks with large datasets", acbuy: "Advanced – Handles millions of rows", traditionalIcon: "ri-close-circle-line text-red-400", acbuyIcon: "ri-checkbox-circle-line text-green-500" },
    { feature: "Optimization Tools", traditional: "None – Basic formulas only", acbuy: "Built-in – Performance analytics suite", traditionalIcon: "ri-close-circle-line text-red-400", acbuyIcon: "ri-checkbox-circle-line text-green-500" },
    { feature: "Template Library", traditional: "Basic – Few default options", acbuy: "Extensive – 50+ industry templates", traditionalIcon: "ri-error-warning-line text-amber-400", acbuyIcon: "ri-checkbox-circle-line text-green-500" },
    { feature: "Collaboration", traditional: "Limited – Version conflicts common", acbuy: "Seamless – Real-time multi-user sync", traditionalIcon: "ri-close-circle-line text-red-400", acbuyIcon: "ri-checkbox-circle-line text-green-500" },
    { feature: "Learning Curve", traditional: "Steep – Requires training", acbuy: "Gentle – Intuitive guided workflows", traditionalIcon: "ri-error-warning-line text-amber-400", acbuyIcon: "ri-checkbox-circle-line text-green-500" },
    { feature: "Updates & Support", traditional: "Infrequent – Community only", acbuy: "Regular – Dedicated support team", traditionalIcon: "ri-close-circle-line text-red-400", acbuyIcon: "ri-checkbox-circle-line text-green-500" },
  ];

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <p className="text-xs md:text-sm text-foreground-500 font-medium tracking-wide mb-3">
              / FEATURE COMPARISON
            </p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-4">
              ACBuySpreadsheet <span className="text-primary-500">vs</span> Traditional Spreadsheet
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
              See why the <strong>acbuyspreadsheet</strong> framework is replacing conventional spreadsheet tools for data professionals and businesses.
            </p>
          </div>

          {/* Comparison table */}
          <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden">
            {/* Table header */}
            <div className="grid grid-cols-12 bg-primary-500 text-background-50 px-4 md:px-6 py-3 md:py-4 text-xs md:text-sm font-semibold">
              <div className="col-span-4">Feature</div>
              <div className="col-span-4 text-center">Traditional Spreadsheet</div>
              <div className="col-span-4 text-center">ACBuySpreadsheet System</div>
            </div>

            {/* Table body */}
            {rows.map((row, idx) => (
              <div
                key={row.feature}
                className={`grid grid-cols-12 px-4 md:px-6 py-3 md:py-4 text-xs md:text-sm border-b border-background-200/50 last:border-b-0 ${
                  idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"
                }`}
              >
                <div className="col-span-4 font-medium text-foreground-800 flex items-center">
                  {row.feature}
                </div>
                <div className="col-span-4 flex items-center justify-center gap-2 text-foreground-500">
                  <i className={row.traditionalIcon}></i>
                  <span className="hidden sm:inline">{row.traditional}</span>
                </div>
                <div className="col-span-4 flex items-center justify-center gap-2 text-foreground-800">
                  <i className={row.acbuyIcon}></i>
                  <span className="hidden sm:inline font-medium">{row.acbuy}</span>
                </div>
              </div>
            ))}
          </div>

          <p className="text-center mt-6 text-xs md:text-sm text-foreground-500">
            This is why <strong>acbuyspreadsheet</strong> is becoming the new standard for data-driven professionals.
          </p>
        </div>
      </div>
    </section>
  );
}